'use strict'

const parseEnvFile  = (prefix) => {
  let result = {}
  Object.keys(process.env).forEach((key) => {
    if (key.startsWith(prefix)) {
      result[key] = process.env[key]
    }
  })
  return result
}

const generateApplicationConfig = () => {
  const appConfiguration = parseEnvFile('REACT_APP')

  return {
    ...appConfiguration,
    isNemi: appConfiguration.REACT_APP_applicationId === 'mobi.nemi',
    isAmb: appConfiguration.REACT_APP_applicationId === 'mobi.nemi.amb',
    isIframe: appConfiguration.REACT_APP_applicationId === 'mobi.nemi.iframe',
    isBeiraBaixa: appConfiguration.REACT_APP_applicationId === 'mobi.nemi.beirabaixa',
    appLogo : appConfiguration.REACT_APP_applicationId === 'mobi.nemi.amb' ? 'ambLogo' : 'nemiLogo'
  }
}

export const Application = generateApplicationConfig()
export const Environment = parseEnvFile('REACT_APP')

export default {
  Application,
  Environment
}
